import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFatCart = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 90,
	height: 133,
	viewBox: "0 0 90 133",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M66.6503 82.3303C68.4238 82.3303 70.1248 83.0329 71.3797 84.2838C72.6347 85.5347 73.341 87.2316 73.3436 89.0019V114.944H59.957V89.0019C59.9597 87.2316 60.666 85.5347 61.921 84.2838C63.1759 83.0329 64.8769 82.3303 66.6503 82.3303Z",
			fill: "#26CA99"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.422 42.3589C42.1091 42.9056 43.5107 44.0983 44.3189 45.6751C45.1272 47.2519 45.276 49.084 44.7328 50.7689L36.736 75.4474L24.0013 71.3209L31.9981 46.6424C32.5463 44.9591 33.7414 43.5625 35.3208 42.7594C36.9002 41.9563 38.735 41.8122 40.422 42.3589Z",
			fill: "#26CA99"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.5 100.296L41 115.296H58L49.5 100.296Z",
			fill: "#DE5727"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.8392 68.8927C61.7004 68.8875 57.7323 67.2453 54.8039 64.3257C51.8755 61.4061 50.2254 57.4472 50.2148 53.3157H60.1603C60.1378 54.0739 60.268 54.8289 60.5432 55.536C60.8183 56.2431 61.2328 56.8879 61.7622 57.4322C62.2915 57.9764 62.9248 58.4091 63.6247 58.7046C64.3246 59 65.0768 59.1523 65.8367 59.1523C66.5966 59.1523 67.3488 59 68.0487 58.7046C68.7485 58.4091 69.3819 57.9764 69.9112 57.4322C70.4405 56.8879 70.8551 56.2431 71.1302 55.536C71.4054 54.8289 71.5356 54.0739 71.5131 53.3157H81.4585C81.4493 57.4467 79.8003 61.4057 76.8727 64.3254C73.945 67.2451 69.9775 68.8875 65.8392 68.8927Z",
			fill: "#DE5727"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.0923 8.32213C47.0927 7.26064 51.3499 7.82482 54.9318 9.89112C58.5137 11.9574 61.1283 15.3574 62.2031 19.3467L52.5936 21.9096C52.4199 21.1712 52.0995 20.4752 51.6515 19.8629C51.2034 19.2506 50.6367 18.7344 49.985 18.3449C49.3333 17.9555 48.6098 17.7006 47.8574 17.5955C47.105 17.4904 46.339 17.5371 45.6048 17.7329C44.8706 17.9288 44.183 18.2697 43.5829 18.7355C42.9828 19.2014 42.4824 19.7826 42.1112 20.4449C41.74 21.1072 41.5056 21.8371 41.422 22.5912C41.3383 23.3453 41.4071 24.1084 41.6242 24.8352L32.0147 27.3981C30.959 23.4042 31.5321 19.154 33.6085 15.5785C35.6848 12.003 39.0951 9.39364 43.0923 8.32213Z",
			fill: "#DE5727"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42.3374 84.1657L58.522 90.7787C56.6485 95.0022 53.1459 98.355 48.7848 100.1C44.4237 101.844 39.5613 101.838 35.2674 100.081C30.9734 98.3251 27.5995 94.9629 25.888 90.7345C24.1765 86.5062 24.2676 81.7579 26.1411 77.5344L42.3374 84.1657Z",
			fill: "#F1B820"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.6722 82.4274L53.6237 83.3556C53.4334 81.6101 53.5976 79.8442 54.1065 78.1635C54.6154 76.4828 55.4586 74.9218 56.5857 73.5737C57.7127 72.2257 59.1005 71.1184 60.666 70.318C62.2316 69.5176 63.9427 69.0406 65.6971 68.9153C67.4516 68.7901 69.2133 69.0193 70.8769 69.5893C72.5406 70.1592 74.0721 71.0582 75.3798 72.2324C76.6875 73.4066 77.7446 74.832 78.4879 76.4234C79.2311 78.0147 79.6453 79.7394 79.7057 81.4941L66.6722 82.4274Z",
			fill: "#F7DED9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42.7336 68.2957L37 74.8779L39.8444 83.1231L48.4174 84.791L54.151 78.2088L51.3115 69.9636L42.7336 68.2957Z",
			fill: "#3032DC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.6844 98.7479L24.9053 103.697L26.5752 110.99L34.0193 113.338L39.7984 108.389L38.1329 101.096L30.6844 98.7479Z",
			fill: "#F7DED9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.8588 30.7403L31.8684 39.411L39.881 42.8564L46.8845 37.6382L45.8749 28.9675L37.8656 25.5184L30.8588 30.7403Z",
			fill: "#F1B820"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.1673 49.5243L45.774 54.5777C44.442 50.4912 44.7873 46.04 46.7341 42.2032C48.6809 38.3665 52.0696 35.4585 56.1547 34.1191C60.2399 32.7796 64.6869 33.1184 68.5174 35.0608C72.348 37.0033 75.2482 40.3903 76.5803 44.4768L61.1673 49.5243Z",
			fill: "#3032DC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M60.1253 33.841L47.0768 34.7692C46.8865 33.0237 47.0507 31.2578 47.5596 29.5771C48.0685 27.8964 48.9117 26.3353 50.0388 24.9873C51.1658 23.6393 52.5536 22.532 54.1192 21.7316C55.6847 20.9312 57.3958 20.4541 59.1502 20.3289C60.9047 20.2037 62.6664 20.4329 64.3301 21.0028C65.9937 21.5728 67.5252 22.4717 68.8329 23.646C70.1406 24.8202 71.1977 26.2456 71.941 27.837C72.6843 29.4283 73.0985 31.1529 73.1588 32.9077L60.1253 33.841Z",
			fill: "#F7DED9"
		}),
		/* @__PURE__ */ _jsxs("mask", {
			id: "path-13-outside-1_4505_74705",
			maskUnits: "userSpaceOnUse",
			x: -.0429688,
			y: 68.4768,
			width: 90,
			height: 57,
			fill: "black",
			children: [/* @__PURE__ */ _jsx("rect", {
				fill: "white",
				x: -.0429688,
				y: 68.4768,
				width: 90,
				height: 57
			}), /* @__PURE__ */ _jsx("path", { d: "M82.6131 117.031C58.7746 124.505 45.692 124.598 22.8856 117.031C21.5338 116.583 20.9406 115.703 20.3992 114.793C12.8065 102.021 12.9689 93.5722 19.8643 76.4408H2.95703V71.4768H22.112C22.7313 71.4739 23.3294 71.7017 23.7893 72.1158C24.2492 72.5299 24.5377 73.1004 24.5984 73.7156C18.3995 93.0764 17.3554 102.313 25.1382 112.067C46.7409 118.974 58.8617 118.792 80.1267 112.067C81.364 107.121 82.6131 104.295 82 95.5224H87C88 103.795 87.4031 107.977 85.0995 114.549C84.7648 115.504 83.6162 116.717 82.6131 117.031Z" })]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.6131 117.031C58.7746 124.505 45.692 124.598 22.8856 117.031C21.5338 116.583 20.9406 115.703 20.3992 114.793C12.8065 102.021 12.9689 93.5722 19.8643 76.4408H2.95703V71.4768H22.112C22.7313 71.4739 23.3294 71.7017 23.7893 72.1158C24.2492 72.5299 24.5377 73.1004 24.5984 73.7156C18.3995 93.0764 17.3554 102.313 25.1382 112.067C46.7409 118.974 58.8617 118.792 80.1267 112.067C81.364 107.121 82.6131 104.295 82 95.5224H87C88 103.795 87.4031 107.977 85.0995 114.549C84.7648 115.504 83.6162 116.717 82.6131 117.031Z",
			fill: "#3032DC",
			stroke: "#3032DC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.6131 117.031C58.7746 124.505 45.692 124.598 22.8856 117.031C21.5338 116.583 20.9406 115.703 20.3992 114.793C12.8065 102.021 12.9689 93.5722 19.8643 76.4408H2.95703V71.4768H22.112C22.7313 71.4739 23.3294 71.7017 23.7893 72.1158C24.2492 72.5299 24.5377 73.1004 24.5984 73.7156C18.3995 93.0764 17.3554 102.313 25.1382 112.067C46.7409 118.974 58.8617 118.792 80.1267 112.067C81.364 107.121 82.6131 104.295 82 95.5224H87C88 103.795 87.4031 107.977 85.0995 114.549C84.7648 115.504 83.6162 116.717 82.6131 117.031Z",
			stroke: "#3032DC",
			strokeWidth: 4.29268,
			mask: "url(#path-13-outside-1_4505_74705)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.5 132.296C33.1944 132.296 37 128.49 37 123.796C37 119.101 33.1944 115.296 28.5 115.296C23.8056 115.296 20 119.101 20 123.796C20 128.49 23.8056 132.296 28.5 132.296Z",
			fill: "#3032DC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.5 132.296C81.1944 132.296 85 128.49 85 123.796C85 119.101 81.1944 115.296 76.5 115.296C71.8056 115.296 68 119.101 68 123.796C68 128.49 71.8056 132.296 76.5 132.296Z",
			fill: "#3032DC"
		})
	]
});
export default SvgFatCart;
